import { render, staticRenderFns } from "./myCertificate.vue?vue&type=template&id=84564e90"
import script from "./myCertificate.vue?vue&type=script&lang=js"
export * from "./myCertificate.vue?vue&type=script&lang=js"
import style0 from "./myCertificate.vue?vue&type=style&index=0&id=84564e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports